import persistReducer from "redux-persist/es/persistReducer";
import { GLOBALTYPES } from "../actions/globalTypes";
import storage from "redux-persist/lib/storage";

const initialState = { loading: false };

const authReducer = persistReducer(
  {
    storage,
    key: "konnect-auth",
  },
  (state = initialState, action) => {
    switch (action.type) {
      case GLOBALTYPES.AUTH:
        return { state, ...action.payload };
      case "SET_AUTH_LOADING":
        return { ...state, loading: action.payload };
      case "logout":
        return {};

      default:
        return state;
    }
  }
);

export default authReducer;
